import { InnerQueryExpression } from "../InnerQueryExpression";

export type StringMatchExpressionKind = "Exact" | "Prefix" | "Substring" | "Suffix";

export class StringMatchExpression implements InnerQueryExpression {
    public readonly $discriminator = "StringMatch";
    public readonly fieldName: string;
    public readonly value: string;
    public readonly matchExpressionKind: StringMatchExpressionKind;
    public readonly isCaseInsensitive: boolean;

    public constructor(
        fieldName: string,
        value: string,
        matchExpressionKind: StringMatchExpressionKind,
        isCaseInsensitive: boolean
    ) {
        this.fieldName = fieldName;
        this.value = value;
        this.matchExpressionKind = matchExpressionKind;
        this.isCaseInsensitive = isCaseInsensitive;
    }
}
